exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".el-tabs__item{font-size:16px}.el-tabs--border-card>.el-tabs__header .el-tabs__item{color:#000}.el-table{font-size:.9em;margin-top:40px;border:1px solid #000}.el-table td,.el-table th{border:.5px solid #000}.el-table__header th{font-size:16px;color:#000}.el-table .cell{white-space:normal;word-break:normal;line-height:23px;padding-left:7px}.el-card{margin-top:5px;border-radius:4px;border:1px solid #000;background-color:#fff;overflow:hidden;color:#303133;transition:.3s}h3{font-size:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f82b52ee","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/AppAllAcceptanceLists.vue
// module id = 474
// module chunks = 0